import React from 'react';
import { categories } from '../data/products';
import {
  Baby,
  Bed,
  Milk,
  Bath,
  HeartPulse,
  Shirt,
  Puzzle,
  Armchair,
  Lamp,
  Pencil,
  Gift,
  Heart
} from 'lucide-react';

const iconMap = {
  baby: Baby,
  bed: Bed,
  'baby-bottle': Milk,
  bath: Bath,
  'heart-pulse': HeartPulse,
  shirt: Shirt,
  puzzle: Puzzle,
  armchair: Armchair,
  lamp: Lamp,
  pencil: Pencil,
  gift: Gift,
  heart: Heart,
};

interface CategoriesProps {
  onCategorySelect: (categoryId: number) => void;
}

export const Categories: React.FC<CategoriesProps> = ({ onCategorySelect }) => {
  return (
    <section className="py-12 bg-pink-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-8">Categories</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {categories.map((category) => {
            const Icon = iconMap[category.icon as keyof typeof iconMap];
            return (
              <button
                key={category.id}
                className="flex flex-col items-center p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow group"
                onClick={() => onCategorySelect(category.id)}
              >
                <Icon className="h-8 w-8 text-pink-500 mb-2 group-hover:scale-110 transition-transform" />
                <span className="text-gray-800 font-medium text-sm text-center">
                  {category.name}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};